import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import index from '../views/index/index.vue'
import course from '../views/course/course.vue'
import server from '../views/serve/server.vue'


export default new Router({
  routes: [
    {
      path: '/',
      name: '首页',
      component: index,
    },
    {
      path: '/course',
      name: '课程',
      component: course,
    },
    {
      path: '/serve',
      name: '服务',
      component: server,
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js